import { pickersOutlinedInputClasses } from "@mui/x-date-pickers/PickersTextField";

import { getInputFocusRingStyles } from "./input-focus-ring";

export const MuiPickersOutlinedInput = {
	defaultProps: { notched: false },
	styleOverrides: {
		root: {
			...getInputFocusRingStyles(
				`&.${pickersOutlinedInputClasses.error}`,
				`&.${pickersOutlinedInputClasses.disabled}`
			),
			"--Input-borderRadius": "8px",
			"--Input-paddingInline": "12px",
			"--Input-minHeight": "32px",
			borderRadius: "var(--Input-borderRadius)",
			paddingInline: "var(--Input-paddingInline)",
			minHeight: "var(--Input-minHeight)",
		},
		notchedOutline: { display: "none" },
	},
};
